<template>
  <v-container style="max-width:100vw;">
    <!-- Filtros -->
    <v-navigation-drawer right v-model="drawer" app>
      <provider-payment-filters @filters="applyFilters" />
    </v-navigation-drawer>

    <!-- Header -->
    <v-toolbar flat class="px-4 pt-3">
        <v-toolbar-title>Pagos a Proveedores</v-toolbar-title>
        <!--v-spacer /-->
        <v-btn icon @click="openDrawer">
            <v-badge :content="filtersCount" v-if="filtersCount > 0" color="primary" overlap>
                <v-icon>mdi-filter</v-icon>
            </v-badge>
            <v-icon v-else>mdi-filter</v-icon>
        </v-btn>
        <v-menu bottom left offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon v-bind="attrs" v-on="on" :loading="exporting">
              <v-icon>mdi-download</v-icon>
            </v-btn>
          </template>
          <v-list dense>
            <v-list-item @click="exportExcel(false)">
              Lo que se ve en pantalla
            </v-list-item>
            <v-list-item @click="exportExcel(true)">
              Todo
            </v-list-item>
          </v-list>
        </v-menu>
    </v-toolbar>

    <!-- Tabla -->
    <v-data-table
      height="calc(100vh - 300px)"
      fixed-header
      :loading="loading"
      :headers="headers"
      :items="providerPayments"
      :server-items-length="meta.total"
      :options.sync="options"
      class="elevation-0 px-6 pb-4 pt-10"
      :footer-props="{ 'items-per-page-options': [10, 25, 50] }"
      show-expand
    >
      <template v-slot:[`item.amount`]="{ item }">
        {{ parseFloat(item.amount).toLocaleString('es-MX', { style: 'currency', currency: 'MXN' }) }}
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <v-menu bottom left>
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon v-bind="attrs" v-on="on">
              <v-icon>mdi-dots-vertical</v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item @click="editItem(item)">
              <v-icon small class="mr-2">mdi-pencil</v-icon> Editar
            </v-list-item>
            <v-list-item @click="item_to_delete = item, sheet = true">
              <v-icon small class="mr-2">mdi-delete</v-icon> Eliminar
            </v-list-item>
          </v-list>
        </v-menu>
      </template>
      <template v-slot:[`item.created_at`]="{ item }">
        {{item.created_at.slice(0, 10)}}
      </template>
      <template v-slot:[`item.updated_at`]="{ item }">
        {{item.updated_at.slice(0, 10)}}
      </template>
      <template v-slot:[`item.pdf`]="{ item }">
        <a :href="liga + 'files/' + item.pdf" v-if="item.pdf!=null" target="_blank">
          <v-icon style="cursor:pointer;">
          mdi-download-circle
          </v-icon>
        </a>
      </template>
      <template v-slot:expanded-item="{ headers, item }">
        <td :colspan="headers.length" class="pb-4">
            <v-row class="pa-6 pb-0">
                <ProviderPaymentDetail :provider_payment_items="item.provider_payment_items"/>
            </v-row>
        </td>
      </template>


      <!-- Footer -->
      <template v-slot:footer>
        <v-container style="margin-bottom:-80px!important;">
          <v-select :items="sumavg" v-model="totalType" style="width: 100px; display: inline-block; margin-right:30px; font-size: 14px;"></v-select>
          <v-select :items="campos" v-model="campo" item-text="text" item-value="value" style="width: 100px; display: inline-block; margin-right:30px; font-size: 14px;"></v-select>
          <strong>{{(totalType=='sum'?'Total = ':'Promedio = ') + ((meta.aggregates && meta.aggregates[campo] && meta.aggregates[campo][totalType] !== undefined ? meta.aggregates[campo][totalType] : 0) * 1).toLocaleString('es-MX', { style: 'currency', currency: 'MXN',}) }}</strong>
        </v-container>
      </template> 
    </v-data-table>

    <!-- Crear/Editar -->
    <v-dialog v-model="dialog" max-width="1080px">
      <provider-payment-form
        v-if="dialog"
        :key="editedItem?.id || new Date()"
        :edited-item="editedItem"
        @saved="onSaved"
        @closed="dialog = false"
      />
    </v-dialog>

    <!-- Botón flotante -->
    <v-btn
      color="primary"
      dark
      fab
      fixed
      bottom
      right
      @click="openCreate"
    >
      <v-icon>mdi-plus</v-icon>
    </v-btn>

    <div class="text-center">
        <v-bottom-sheet  v-model="sheet" inset>
            <v-sheet class="text-center" height="150px">
                <div class="pt-6">
                ¿Seguro que deseas eliminar el pago a proveedor {{item_to_delete?.id}}?
                </div>
                <v-btn class="mt-4" text color="grey" @click="item_to_delete = undefined, sheet = false">
                Cancelar
                </v-btn>
                <v-btn class="mt-4" text color="error" @click="deleteProviderPayment()">
                Eliminar
                </v-btn>
                
            </v-sheet>
        </v-bottom-sheet>
    </div>
  </v-container>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
import ProviderPaymentFilters from "./filter.vue";
import ProviderPaymentForm from "./form.vue";
import ProviderPaymentDetail from "./detail/table.vue"

export default {
  components: {
    ProviderPaymentFilters,
    ProviderPaymentForm,
    ProviderPaymentDetail
  },
  data() {
    return {
        campo:'amount',
        campos:[
            { text: 'Monto', value: 'amount' },
        ],
        totalType:'sum',
        sumavg:['sum', 'avg'],
        filtersCount: 0,
        item_to_delete:undefined,
        sheet:false,
        drawer: false,
        dialog: false,
        editedItem: null,
        exporting: false,
        page: 1,
        options: {
            page: 1,
            itemsPerPage: 10,
        },
        filters: {},
        headers:[
            { text: 'Fecha', value: 'date' },
            { text: 'Monto', value: 'amount' },
            { text: 'Metodo', value: 'payment_method.name' },
            { text: 'Nota', value: 'note' },
            { text: 'Proveedor', value: 'provider.name' },
            { text: 'Comprobante', value: 'pdf' },
            { text: 'Creación', value: 'created_at' },
            { text: 'Creador', value: 'created_by_user_id'},
            { text: 'Edición', value: 'updated_at' },
            { text: 'Editor', value: 'last_updated_by_user_id'},
            { value: 'actions', sortable: false, align: 'end' },
        ],
    };
  },
  computed: {
    ...mapGetters("providerPayment", [
      "providerPayments",
      "loading",
      "meta",
    ]),
    liga(){
      return process.env.VUE_APP_BACKEND_ROUTE
    }
  },
  watch: {
    options: {
      handler() {
        this.fetchData();
      },
      deep: true,
    },
    page(val) {
      this.options.page = val;
      this.fetchData();
    },
  },
  created() {
    this.fetchData();
  },
  methods: {
    openDrawer(){
      if(this.drawer == false){
          this.$emit("closeDrawer", false);
          this.drawer = true
      }else{
          this.$emit("closeDrawer", true);
          this.drawer = false
      }
    },
    applyFilters(filters, count) {
        this.filters = filters;
        this.filtersCount = count;
        this.options.page = 1;
        this.fetchData();
        this.drawer = false;
    },
    fetchData() {
      const params = {
        ...this.filters,
        page: this.options.page,
        itemsPerPage: this.options.itemsPerPage,
      };
      this.$store.dispatch("providerPayment/getProviderPayments", params);
    },
    buildExportParams(all = false) {
      return {
        ...this.filters,
        page: all ? 1 : this.options.page,
        itemsPerPage: all ? (this.meta?.total || this.options.itemsPerPage) : this.options.itemsPerPage,
        export: 1,
      };
    },
    getExportFilename(response) {
      const disposition = response.headers?.["content-disposition"] || "";
      const match = disposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/i);
      if (match && match[1]) {
        return match[1].replace(/['"]/g, "");
      }
      return `provider_payments_${new Date().toISOString().slice(0, 10)}.xlsx`;
    },
    downloadFile(blobData, filename) {
      const url = window.URL.createObjectURL(new Blob([blobData]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    },
    async exportExcel(all = false) {
      this.exporting = true;
      try {
        const response = await axios.get(
          `${process.env.VUE_APP_BACKEND_ROUTE}api/v2/provider_payments`,
          {
            responseType: "blob",
            headers: {
              Accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            },
            params: this.buildExportParams(all),
          }
        );
        this.downloadFile(response.data, this.getExportFilename(response));
      } finally {
        this.exporting = false;
      }
    },
    openCreate() {
      this.editedItem = null;
      this.dialog = true;
    },
    editItem(item) {
      this.editedItem = { ...item };
      this.dialog = true;
    },
    onSaved() {
      this.dialog = false;
      this.fetchData();
    },
    deleteProviderPayment() {
        this.$store
            .dispatch("providerPayment/deleteProviderPayment", this.item_to_delete.id)
            .then(response => {
            
            this.sheet = false
                this.snackbar = {
                    message: 'Pago a proveedor eliminado',
                    color: 'success',
                    show: true
                }
                
                this.fetchData()
    });
    },
  },
};
</script>
